import React, { useState, useEffect } from 'react';
import { Map } from 'immutable';
import axios from 'axios';
import Config from "../settings/urbanice-api";
import { siteConfig } from "../settings";


const DEBUG = siteConfig.DEBUG
const UNSUBSCRIBE_WEBNITI_NOTI = Config.UNSUBSCRIBE_WEBNITI_NOTI;

export function clearToken() {

  DEBUG && console.log('clearToken');

  localStorage.removeItem('id_token');
  window.localStorage.removeItem('communityFeatureList')
  localStorage.removeItem('access_token');
  localStorage.removeItem('userID');
  localStorage.removeItem('userBadgeUrl');
  localStorage.removeItem('userImageUrl');
  localStorage.removeItem('communityName');
  localStorage.removeItem('userFirstname');
  localStorage.removeItem('userLastname');
  localStorage.removeItem('communityID');
  localStorage.removeItem('userDisplayStatus');

  window.localStorage.clear();

}

export function unsubscribeFcm() {
  DEBUG && console.log('unsubscribeFcm');

  const fcmToken = localStorage.getItem("fcmToken");
  DEBUG && console.log("fcmToken: " + fcmToken);

  let axiosConfig = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "Bearer " + this.state.userToken
    },
    data: {
      'fcmToken': fcmToken,
    }
  };

  axios
    .delete(UNSUBSCRIBE_WEBNITI_NOTI, axiosConfig)
    .then((response) => {
      const resData = response.data
      DEBUG && console.log('unsubscribeFcm_unsubscribe: ' + JSON.stringify(resData));
      localStorage.removeItem('fcmToken');
    })
    .catch((error) => {
      DEBUG && console.log('unsubscribeFcm_response.error: ' + error);
    })

}

export function getToken() {
  try {
    const idToken = localStorage.getItem('id_token');
    return new Map({ idToken });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = number => {
    return number > 1 ? 's' : '';
  };
  const number = num => (num > 9 ? '' + num : '0' + num);
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return days + ' day' + numberEnding(days);
      } else {
        const months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
        const month = months[givenTime.getUTCMonth()];
        const day = number(givenTime.getUTCDate());
        return `${day} ${month}`;
      }
    }
    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return 'a few seconds ago';
  };
  return getTime();
}
